import { ParameterType } from '@/study-search/enums';

import { FilterOptionInformation } from '@studyportals/search-filters';

export abstract class FilterDefinition {
	public constructor(
		public readonly type: ParameterType,
		public readonly filterInformation: FilterOptionInformation[],
		public readonly indexableFilterOptionValues: string[],
		public readonly isRequired = false
	) {}

	public getOptionValue(path: string): string {
		if (this.exists(path)) {
			return this.filterInformation.filter((_) => _.optionPath === path)[0].optionValue;
		}

		return '';
	}

	public exists(path: string): boolean {
		return this.filterInformation.some((_) => _.optionPath === path);
	}

	public getPathRegex(): string {
		return this.filterInformation
			.filter((_) => _.optionPath !== '')
			.map((_) => _.optionPath)
			.join('|');
	}

	public getFilterOption(id: string): FilterOptionInformation {
		return this.filterInformation.filter((_) => _.optionValue === id)[0];
	}
}
